import Invoice from "../../entities/invoice";

/**
 * Invoice actions
 *
 * Call order:
 *
 * INVOICE_SAVE_QUEUE:	adds the item to the save queue
 * --> INVOICE_SAVE:	modifies the state
 * --> INVOICE_SAVE_SUCCESS: if all went well
 * --> INVOICE_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail INVOICE_SAVE_QUEUE is during the call to INVOICE_SAVE,
 * as adding an item to the queue should never fail.
 */

export const INVOICE_FETCH_ONE_QUEUE: any = 'INVOICE_FETCH_ONE_QUEUE';
export const INVOICE_FETCH_SUCCESS: any = 'INVOICE_FETCH_SUCCESS';
export const INVOICE_FETCH_FAILURE: any = 'INVOICE_FETCH_FAILURE';
export const INVOICE_FETCH_ONE_SUCCESS: any = 'INVOICE_FETCH_ONE_SUCCESS';
export const INVOICE_FETCH_ONE_FAILURE: any = 'INVOICE_FETCH_ONE_FAILURE';

export const INVOICE_SAVE: any = 'INVOICE_SAVE';
export const INVOICE_SAVE_QUEUE: any = 'INVOICE_SAVE_QUEUE';
export const INVOICE_SAVE_SUCCESS: any = 'INVOICE_SAVE_SUCCESS';
export const INVOICE_SAVE_FAILURE: any = 'INVOICE_SAVE_FAILURE';

export const INVOICE_SAVE_MANY: any = 'INVOICE_SAVE_MANY';
export const INVOICE_SAVE_MANY_QUEUE: any = 'INVOICE_SAVE_MANY_QUEUE';
export const INVOICE_SAVE_MANY_SUCCESS: any = 'INVOICE_SAVE_MANY_SUCCESS';
export const INVOICE_SAVE_MANY_FAILURE: any = 'INVOICE_SAVE_MANY_FAILURE';

export const INVOICE_REMOVE: any = 'INVOICE_REMOVE';
export const INVOICE_REMOVE_QUEUE: any = 'INVOICE_REMOVE_QUEUE';
export const INVOICE_REMOVE_SUCCESS: any = 'INVOICE_REMOVE_SUCCESS';
export const INVOICE_REMOVE_FAILURE: any = 'INVOICE_REMOVE_FAILURE';

export const INVOICE_RESTORE: any = 'INVOICE_RESTORE';
export const INVOICE_RESTORE_QUEUE: any = 'INVOICE_RESTORE_QUEUE';
export const INVOICE_RESTORE_SUCCESS: any = 'INVOICE_RESTORE_SUCCESS';
export const INVOICE_RESTORE_FAILURE: any = 'INVOICE_RESTORE_FAILURE';

export const INVOICE_RESTORE_MANY: any = 'INVOICE_RESTORE_MANY';
export const INVOICE_REMOVE_MANY: any = 'INVOICE_REMOVE_MANY';

/* Fetch actions */
export const fetchInvoiceSuccess = (invoices: Invoice[], partial: boolean, lastFetch: number) => ({type: INVOICE_FETCH_SUCCESS, invoices, partial, lastFetch});
export const fetchInvoiceFailure = (err: any) => {
		console.error('InvoiceAction: fetchInvoiceFailure', err);
		return {type: INVOICE_FETCH_FAILURE, err};
};
export const fetchOneInvoiceQueue = (invoiceId: string) => ({type: INVOICE_FETCH_ONE_QUEUE, invoiceId});
export const fetchOneInvoiceSuccess = (invoice: Invoice) => ({type: INVOICE_FETCH_ONE_SUCCESS, invoice});
export const fetchOneInvoiceFailure = (id: string, err: any) => {
		console.error('InvoiceAction: fetchOneInvoiceFailure', err);
		return {type: INVOICE_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveInvoice = (invoice: Invoice) => {
    // console.debug('⮂ INVOICE_SAVE action', invoice?.id);
    return {type: INVOICE_SAVE, invoice};
}
export const saveInvoiceQueue = (invoice: Invoice, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ INVOICE_SAVE_QUEUE action', invoice?.id);
    return {type: INVOICE_SAVE_QUEUE, invoice, onQueued};
}
export const saveInvoiceSuccess = (invoice: Invoice) => {
    // console.debug('⮂ INVOICE_SAVE_SUCCESS action', invoice?.id);
    return {type: INVOICE_SAVE_SUCCESS, invoice};
}
export const saveInvoiceFailure = (invoice: Invoice, status: number, message: string) => {
    console.warn(`⮂ INVOICE_SAVE_FAILURE error saving invoice: HTTP ${status}: ${message}`, invoice?.id);
    return {type: INVOICE_SAVE_FAILURE, invoice, status, message};
};

/* SaveMany actions */
export const saveManyInvoices = (invoices: Invoice[]) => {
    // console.debug('⮂ INVOICE_SAVE_MANY action', invoices?.map(invoice => invoice?.id).join(','));
    return {type: INVOICE_SAVE_MANY, invoices};
}
export const saveManyInvoicesQueue = (invoices: Invoice[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ INVOICE_SAVE_MANY_QUEUE action', invoices?.map(invoice => invoice.id).join(','));
    return {type: INVOICE_SAVE_MANY_QUEUE, invoices, onQueued};
}

export const saveManyInvoicesSuccess = (invoices: Invoice[]) => {
    // console.debug('⮂ INVOICE_SAVE_MANY_SUCCESS action', invoices?.map(invoice => invoice.id).join(','));
    return {type: INVOICE_SAVE_MANY_SUCCESS, invoices};
}
export const saveManyInvoicesFailure = (invoices: Invoice[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_INVOICES_FAILURE Error saving invoices: HTTP ${status}: ${message}`, invoices?.map(invoice => invoice.id).join(','));
		return {type: INVOICE_SAVE_MANY_FAILURE, invoices, status, message};
};

/* Remove actions */
export const removeInvoice = (invoice: Invoice) => ({ type: INVOICE_REMOVE, invoice });
export const removeInvoiceQueue = (invoice: Invoice) => ({ type: INVOICE_REMOVE_QUEUE, invoice });
export const removeInvoiceSuccess = (invoice: Invoice) => ({ type: INVOICE_REMOVE_SUCCESS, invoice });
export const removeInvoiceFailure = (invoice: Invoice, status: number, message: string) => {
	console.error(`Redux: removeInvoiceFailure Error removing invoice: HTTP ${status}: ${message}`);
	return ({ type: INVOICE_REMOVE_FAILURE, invoice, status, message });
};

/* Restore actions */
export const restoreInvoice = (invoice: Invoice) => ({ type: INVOICE_RESTORE, invoice });
export const restoreInvoiceQueue = (invoice: Invoice) => ({ type: INVOICE_RESTORE_QUEUE, invoice });
export const restoreInvoiceSuccess = (invoice: Invoice) => ({ type: INVOICE_RESTORE_SUCCESS, invoice });
export const restoreInvoiceFailure = (invoice: Invoice, status: number, message: string) => {
	console.error(`Redux: restoreInvoiceFailure Error restoring invoice: HTTP ${status}: ${message}`);
	return ({ type: INVOICE_RESTORE_FAILURE, invoice, status, message });
};

/* RestoreMany actions */
export const restoreManyInvoices = (invoices: Invoice[]) => ({ type: INVOICE_RESTORE_MANY, invoices });

/* RemoveMany actions */
export const removeManyInvoices = (invoices: Invoice[]) => ({ type: INVOICE_REMOVE_MANY, invoices });